import { Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { LPGDistData, LPGDistService, ToolbarItem } from '../../../lpg-dist.service';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import momentJ from 'moment-jalaali';
import { saveAs } from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { DateRange } from '../../../../shared/components/date-range.component';
import { KeycloakService } from 'src/app/authentication/keycloak.service';
import { forkJoin } from 'rxjs';
import { LpgDistToolbarComponent } from 'src/app/lpg-dist/lpg-dist-toolbar/lpg-dist-toolbar.component';
import { UserLocalStoreService } from 'src/app/shared/services/user-local-store.service';
import {
  PgDateRangeTitleComponent, PgDateRangeTitleEnum, PgTitleComponent,
  PgToolbarComponent
} from '../../../../shared/components/title-bar/title-bar.component';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

interface LpgDistDetailComponentSettings {
  companyId: string;
}

@Component({
  selector: 'app-lpg-dist-detail',
  templateUrl: './lpg-dist-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, AgGridModule],
})
export class LpgDistDetailComponent implements OnInit,
  PgTitleComponent, PgDateRangeTitleComponent, PgToolbarComponent {

  title = new EventEmitter<string>();
  dateRangeSubTitle = new EventEmitter<[DateRange, PgDateRangeTitleEnum]>();
  toolbarComponentType = LpgDistToolbarComponent;
  toolbarComponent!: LpgDistToolbarComponent;
  search!: string;
  dateRange!: DateRange;
  organisations!: Organisation[];
  _organisationsCache: { [key: string]: Organisation } = {};
  selectedOrganisation!: Organisation;
  lpgDistData!: LPGDistData[];
  _settings!: LpgDistDetailComponentSettings;

  constructor(
    private _lpgDistService: LPGDistService,
    private _activateRoute: ActivatedRoute,
    private _keycloakService: KeycloakService,
    private _router: Router,
    private _organisationService: OrganisationService,
    private _userLocalStorage: UserLocalStoreService,
    private _renderer: Renderer2) { }

  gridOptions: GridOptions = {};
  gridRestored: boolean = false;

  columnDefs = [
    {
      headerName: 'تاریخ', field: 'loadTimestamp',
      cellRenderer: (params:ICellRendererParams) =>
        (params.data.loadTimestamp) ? DateTimeHelpers.formatPersianLocalDate(params.data.loadTimestamp) : '',
      width: 130
    },

    { headerName: 'مبدا', field: 'source',
      width: 120
    },

    { headerName: 'شماره بارنامه', field: 'billOfLadingNumber',
      width: 200
    },

    { headerName: 'نام راننده', field: 'driverName',
      width: 150
    },

    { headerName: 'شماره کشنده', field: 'truckNumber',
      width:150
    },

    { headerName: 'شماره تانکر', field: 'tankNumber', width: 150},

    {
      headerName: 'مقصد ابتدایی', field: 'primaryDestination',
      valueFormatter: (params:ICellRendererParams) => this.findOrganisationName(params.data.primaryDestination),
      filterValueGetter: (params:ICellRendererParams) => this.findOrganisationName(params.data.primaryDestination),
      width: 170
    },

    { headerName: 'مقصد', field: 'destination',
      width: 170
    },

    {
      headerName: 'وزن', field: 'loadingWeight',
      cellRenderer: (params:ICellRendererParams) => parseInt(params.data.loadingWeight).toLocaleString('en-US'),
      width: 120
    },

    {
      headerName: 'تخلیه', field: 'unload',
      cellRenderer: (params:ICellRendererParams) => AgGridService.checkBox(
        this._renderer,
        this._lpgDistService,
        this.unloadCheckbox,
        params.data,
        params.data.unload
      ),
      width: 100
    },

    {
      headerName: 'تایید', field: 'verify',
      cellRenderer: (params:ICellRendererParams) => AgGridService.checkBox(
        this._renderer,
        this._lpgDistService,
        this.verifiedCheckbox,
        params.data,
        params.data.verify
      ),
      width: 100
    },

    {
      headerName: 'ویرایش',
      cellRenderer: (params:ICellRendererParams) => {
        const container = this._renderer.createElement('div');
        container.style.display = 'flex';
        container.style.gap = '6px';

        const editBtn = AgGridService.editButton(
          this._renderer,
          this._router,
          this.editRecord,
          params.data
        );

        this._renderer.appendChild(container, editBtn);

        return container;
      },
      width: 100, minWidth: 50
    }

  ];

  ngOnInit() {
    this.gridOptions = AgGridService.getOptions();
    this.getParams();
    this.toolbarComponent.excelExport = this.xlsxReport;
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  saveGridState(event: GridReadyEvent) {
    AgGridService.saveGridState(event, this.gridRestored, this._userLocalStorage, 'lpgGrid');
  }

  restoreGridState(event: GridReadyEvent) {
    this.gridRestored = AgGridService.restoreGridState(event, this._userLocalStorage, 'lpgGrid');
  }

  verifiedCheckbox(service: LPGDistService, data: LPGDistData) {
    data.verify = !data.verify;
    service.update(data).subscribe(() => { console.log('data modified'); });
  }

  unloadCheckbox(service: LPGDistService, data: LPGDistData) {
    data.unload = !data.unload;
    service.update(data).subscribe(() => { console.log('data modified'); });
  }

  setToolbar() {
    this.toolbarComponent.dateRange = {
      startDate: this.dateRange.startDate,
      endDate: this.dateRange.endDate
    };
    this.toolbarComponent.jalali = true;
    this.toolbarComponent.singleDate = false;
    this.toolbarComponent.visibleOrganisation = true;
    this.toolbarComponent.organisations = this.organisations
      .filter(o => ['domestic'].filter(s => o.properties[s]).length > 0);
    this.toolbarComponent.selectedOrganisation = this.selectedOrganisation;
    this.toolbarComponent.itemsSelected.subscribe(t => {
      this.refresh(t);
    });
  }

  getParams() {
    this._activateRoute.queryParams.subscribe(p => {
      this._settings = this._userLocalStorage.get<LpgDistDetailComponentSettings>('LpgDistDetailComponent');
      const company = (p['company']) ? p['company'] : (this._settings) ? this._settings.companyId : 'iran.parsagroup.orsagas';
      const endDate = (p['endTime']) ? +p['endTime'] : momentJ().endOf('day').toDate().getTime();
      const startDate = (p['startTime']) ? +p['startTime'] : momentJ(endDate).startOf('jMonth').toDate().getTime();
      this.title.emit('Loading List');
      this.dateRange = {
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
      this.dateRangeSubTitle.emit([this.dateRange, PgDateRangeTitleEnum.persian]);
      this.updateTable(company, startDate, endDate);
    });
  }

  updateTable(
    company: string,
    startDate: number,
    endDate: number,
  ) {
    forkJoin([
      this._organisationService.get(),
      this._lpgDistService.getOrganisationSummary(
        company,
        startDate,
        endDate)
    ]).subscribe(results => {
      this.organisations = results[0];
      this._organisationsCache = this.organisations.reduce<{ [key: string]: Organisation }>((hashMap, organisation) => {
        hashMap[organisation.name] = organisation;
        return hashMap;
      }, {});
      this.selectedOrganisation = this._organisationsCache[company];
      this.setToolbar();
      this.lpgDistData = results[1].sort((l1, l2) => l1.loadTimestamp - l2.loadTimestamp);
    });
  }

  hasRole(roleName: string) {
    return this._keycloakService.hasRole(roleName);
  }

  editRecord(_router: Router, selectedRecord: LPGDistData) {
    if (selectedRecord.billOfLadingNumber === '') {
      _router.navigate(['/lpg-dist/data-entry/niopdc',
        encodeURIComponent(selectedRecord.companyId),
        encodeURIComponent(selectedRecord.loadTimestamp.toString()),
      ])
        .then(_ => _);
    } else {
      _router.navigate(['/lpg-dist/data-entry/edit',
        encodeURIComponent(selectedRecord.companyId),
        encodeURIComponent(selectedRecord.loadTimestamp.toString()),
        encodeURIComponent(selectedRecord.billOfLadingNumber)])
        .then(_ => _);
    }
  }

  findOrganisationName(organisationId: string) {
    const organisation = this._organisationsCache[organisationId];
    return (organisation) ? organisation.nameTranslations['fa'] : '';
  }

  xlsxReport(lpgDistService: LPGDistService, dateRange: DateRange, organisationId?: string) {
    lpgDistService.downloadLoadingExcel(organisationId || '',
      dateRange.startDate.getTime(),
      dateRange.endDate.getTime()).subscribe(file => {
      saveAs(file.body || '', 'lpg-dist-loadings.xlsx');
    });
  }

  refresh(item: ToolbarItem) {
    const companyId = item.companyId ?? '';
    this._settings = {
      companyId
    };
    this._userLocalStorage.save('LpgDistDetailComponent', this._settings);
    this._router.navigate(['lpg-dist/detail'], {
      queryParams: {
        company: this.organisations.find(o => o.name === companyId)?.name ?? '',
        startTime: item.dateRange?.startDate.getTime(),
        endTime: item.dateRange?.endDate.getTime(),
      }
    });
  }

}
